function loadScripts(urls, callback){

  $.getMultiScripts = function(arr, path) {
    var _arr = $.map(arr, function(scr) {
      return $.getScript( (path||"") + scr );
    });

    _arr.push($.Deferred(function( deferred ){
      $( deferred.resolve );
    }));
    return $.when.apply($, _arr);
  }
  $.getMultiScripts(urls).done(function(){
    callback(window.FB)
  }).fail(function(error){
    console.log(error);
  })
}
let initialized = false;

function fb(callback, appId) {
  if (initialized) {
    callback(window.FB);
  } else {
    if (!window.fbAsyncInit) {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: appId, 
          autoLogAppEvents: true,
          xfbml: false,
          version: 'v12.0',
        });
        initialized = true;
      };
      const script = window.localStorage.getItem('fb:debug') === 'true'
        ? 'xfbml.customerchat/debug.js'
        : 'xfbml.customerchat.js';
      loadScripts([`https://connect.facebook.net/en_US/sdk/${script}`], (FB)=> (callback(FB)) );
    }
  }
}



import { Controller } from "stimulus"
export default class extends Controller {
  static get targets(){
    return [];
  }

 initialize() {
    fb((FB)=>{FB.XFBML.parse()}, this.data.get('appId'))
  }
  connect(){
    if (window.FB && window.FB.CustomerChat){
      window.FB.CustomerChat.show()
    }
  }

  disconnect(){
   if (window.FB && window.FB.CustomerChat){
    this.element.innerHTML = ''
    document.querySelector('#fb-root').innerHTML = ''
    //window.FB.CustomerChat.hide()

   }
    //clearTimeout(this.timeout);
    //delete this.timeout;
  }



}



